import { applyMiddleware, createStore } from 'redux'; // Middleware
// import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import reducer from './reducers';

const createDevelopmentMiddleware = () => {
    // const logger: Middleware = createLogger();
    return applyMiddleware(thunk); // logger
}
const createProductionMiddleware = () => {
    return applyMiddleware(thunk);
};

const middleware = process.env.NODE_ENV !== 'production' ? createDevelopmentMiddleware() : createProductionMiddleware();
const store = createStore(reducer, middleware);

export default store;
